import { render } from "./NotebookSnapshotContainer.vue?vue&type=template&id=40a87d9a"
import script from "./NotebookSnapshotContainer.vue?vue&type=script&lang=js"
export * from "./NotebookSnapshotContainer.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__